var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiLinkedinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94 4.99905C6.93974 5.52948 6.72877 6.03808 6.35351 6.41297C5.97825 6.78785 5.46944 6.99831 4.939 6.99805C4.40857 6.99778 3.89997 6.78681 3.52508 6.41155C3.1502 6.03629 2.93974 5.52748 2.94 4.99705C2.94027 4.46661 3.15124 3.95801 3.5265 3.58313C3.90176 3.20824 4.41057 2.99778 4.941 2.99805C5.47144 2.99831 5.98004 3.20928 6.35492 3.58454C6.72981 3.9598 6.94027 4.46861 6.94 4.99905ZM7 8.47905H3V20.999H7V8.47905ZM13.32 8.47905H9.34V20.999H13.28V14.429C13.28 10.769 18.05 10.429 18.05 14.429V20.999H22V13.069C22 6.89905 14.94 7.12905 13.28 10.159L13.32 8.47905Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiLinkedinFill);
export default __webpack_public_path__ + "static/media/ri_linkedin-fill.a9cc836b45fd0d23cb31738107a12478.svg";
export { ForwardRef as ReactComponent };